import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=0ac421d2&scoped=true&"
import script from "./Supervisor.vue?vue&type=script&lang=js&"
export * from "./Supervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac421d2",
  null
  
)

export default component.exports